import { render } from "./CCOReferrals.vue?vue&type=template&id=0560c708&scoped=true&lang=pug"
import script from "./CCOReferrals.vue?vue&type=script&lang=js"
export * from "./CCOReferrals.vue?vue&type=script&lang=js"

import "./CCOReferrals.vue?vue&type=style&index=0&id=0560c708&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0560c708"]])

export default __exports__